import React from "react";
import { Modal, Button } from "react-bootstrap";
import CustomIcons from "../../../components/icons/kIcons.component";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";

export default function MoreDetailsVendors(props) {
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const handleNav = (d, a) => {
    if (a === "live") {
      window.open(`${result}/${d}`, "_blank");
    } else {
      if (d.startsWith("https://")) {
        window.open(`${d}`, "_blank");
      } else {
        window.open(`https://${d}`, "_blank");
      }
    }
  };
  return (
    <Modal
      {...props}
      show={props.open}
      onHide={(e) => props.handleClose()}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header >
        <Modal.Title
          id="contained-modal-title-vcenter"
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {props.data?.company_name}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="">
          <div className="">
            <div className="comp-item-header">
              <div className="comp-item-logo">
                {props.data?.logo ? (
                  <img
                    className="comp-item-img-logo"
                    alt=""
                    src={`${result}/${props.data?.logo}`}
                  />
                ) : (
                  <div style={{ color: "white",padding:"47px"}}>
                    {props.data?.company_name?.[0]?.toUpperCase()}
                  </div>
                )}

              </div>
              <div className="comp-item-header-data">
                <div className="d-flex">
                  <div className="comp-item-comp-title" style={{ display:"flex",wordBreak: "break-word",width:"500px" }}>
                    {props.data?.company_name}
                  </div>
                </div>

                <div className="d-flex">
                  <CustomIcons
                    iconName="people"
                    iconClass="comp-item-data-icons"
                  />

                  <div className="comp-item-person-name" style={{ display:"flex",wordBreak: "break-word",width:"500px" }}>
                    {props.data?.name}
                  </div>
                </div>
                <div className="d-flex">
                  <div>
                    <CustomIcons
                      iconName="mail"
                      iconClass="comp-item-data-icons"
                    />
                  </div>
                  <div className="text-break">{props.data?.email}</div>
                </div>
                <div className="d-flex">
                  <div>
                    <CustomIcons
                      iconName="phone"
                      iconClass="comp-item-data-icons"
                    />
                  </div>
                  <div className="text-break">{props.data?.phone}</div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex justify-content-start mt-4">
              </div>
              <div className="d-flex row " style={{ cursor: "pointer" }}>
                <div className="mb-4">
                  <Button
                    className="bg-primary"
                    onClick={(e) =>
                      handleNav(props?.data?.brochure, "live")
                    }
                  >
                    Brochure
                  </Button>
                </div>
              </div>

            </div>
            
            <div className="comp-item-product-prof-cont">
              <b>Company Description</b>
              <hr />
              {props?.data?.company_description}
            </div>
            <div className="comp-item-product-prof-cont">
              <b>Area Of Operation</b>
              <hr />
              {props?.data?.area_of_operation}
            </div>


          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={(e) => props.handleClose()}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}
